<template>
    <DFormRow
        :label="__('customers.contracts.fulfillment_strategy')"
        :error="errors.fulfillment_strategy_id"
        :hint="__('customers.contracts.fulfillment_strategy_hint')"
    >
        <DSelect
            id="fulfillment_strategy"
            :model-value="modelValue"
            :options="fulfillmentStrategyOptions"
            @update:modelValue="emit('update:modelValue', $event)"
        />
    </DFormRow>
</template>

<script setup>
import { computed } from 'vue'
import { __ } from '~@/Composables/translation'

const emit = defineEmits('update:modelValue')

const props = defineProps({
    fulfillmentStrategies: {
        type: Array,
        default: () => []
    },
    modelValue: {
        type: Boolean,
        default: false
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const fulfillmentStrategyOptions = computed(() => {
    return props.fulfillmentStrategies.map((strategyId) => ({
        value: strategyId,
        label: __(`products.fulfillmentStrategies.values.${strategyId}`)
    }))
})
</script>
